import { NgModule } from "@angular/core";
import { UiButtonComponent } from "./button.component";
import { UiButtonGroupComponent } from "./components/button-group/button-group.component";
import { UiButtonSplitComponent } from "./components/button-split/button-split.component";
import { UiTransButtonDirective } from "./directives/ui-trans-button.directive";

@NgModule({
  imports: [UiButtonComponent, UiButtonGroupComponent, UiTransButtonDirective, UiButtonSplitComponent],
  exports: [UiButtonComponent, UiButtonGroupComponent, UiTransButtonDirective, UiButtonSplitComponent],
})
export class UiButtonModule {}
